import { add, reduce } from 'ramda';

const roundToTwo = (num) => {
    return +(Math.round(num + 'e+2')  + 'e-2');
};
const calculatePercentage = (obtained, total) => {
    if (obtained === 0 || total === 0) {
      return 0;
    }

    return ((obtained * 100) / total).toFixed(0);
};

const sumArray = reduce(add, 0);

export {
    roundToTwo,
    calculatePercentage,
    sumArray,
};
